import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITable from 'UIComponents/table/UITable';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import UIIcon from 'UIComponents/icon/UIIcon';

// Needed to maintain the side border stylining overridden implicitly by the private UIPanel classes
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UITableWithBorderOverride = styled(UITable).withConfig({
  displayName: "DifferentObjectWebhookEventsTable__UITableWithBorderOverride",
  componentId: "sc-1ig3wco-0"
})(["border-width:0 1px 1px !important;"]);
const DifferentObjectWebhookEventsTable = ({
  webhooks,
  setWebhookStagedForDeletion
}) => {
  return /*#__PURE__*/_jsxs(UITableWithBorderOverride, {
    condensed: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editTable.headers.eventName"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.editTable.headers.objectType"
          })
        }), /*#__PURE__*/_jsx("th", {})]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: webhooks.map((webhook, index) => /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: webhook.label
        }), /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(ObjectTypeName, {
            objectTypeId: webhook.objectTypeId,
            isCapitalized: true
          })
        }), /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(UIFlex, {
            wrap: "nowrap",
            justify: "end",
            children: /*#__PURE__*/_jsx(UIIconButton, {
              size: "xs",
              onClick: () => setWebhookStagedForDeletion(webhook),
              tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation-ui-enrollment.webhookWizard.editTable.actions.delete"
              }),
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "delete"
              })
            })
          })
        })]
      }, index))
    })]
  });
};
export default DifferentObjectWebhookEventsTable;